import { Component, inject, OnInit } from '@angular/core';
import { Router, RouterOutlet } from '@angular/router';
import { BimboSpinner } from './shared/components/bimbo-spinner/bimbo-spinner';
import { AppStartupService } from './core/services/app-startup';
import { AuthService } from './core/auth/auth-service';
import { finalize } from 'rxjs';
import { TranslateService } from '@ngx-translate/core';
import { TranslationService } from './core/services/translation-service';

@Component({
  selector: 'app-root',
  imports: [RouterOutlet, BimboSpinner],
  templateUrl: './app.html',
  styleUrl: './app.css',
})
export class App implements OnInit {
  private readonly authService = inject(AuthService);
  private readonly startupService = inject(AppStartupService);
  private readonly router = inject(Router);
  private readonly translationService = inject(TranslationService);
  private readonly translateService = inject(TranslateService);

  isLoading = this.startupService.isLoading;

  ngOnInit(): void {
    const urlLang = this.translationService.currentLangOnStandard(this.translateService);

    const currentPath = window.location.pathname;

    const skipRestoreRoutes = ['/auth', '/forbidden'];

    if (skipRestoreRoutes.some((route) => currentPath.includes(route))) {
      this.startupService.isLoading.set(false);
      return;
    }
    const publicRoutes = ['/register-attendance'];

    this.authService
      .restoreSession()
      .pipe(
        finalize(() => {
          this.startupService.isLoading.set(false);
        }),
      )
      .subscribe({
        next: (success) => {
          if (!success && this.authService.isADAuthenticated()) {
            void this.router.navigate([`/${urlLang}/forbidden`]);
            return;
          }

          if (!this.authService.isADAuthenticated()) {
            const isPublicRoute = publicRoutes.some(
              (route) => currentPath === `/${urlLang}${route}` || currentPath.endsWith(route),
            );

            if (!isPublicRoute) {
              void this.router.navigate([`/${urlLang}/login`]);
            }
          }
        },
        error: () => {
          void this.router.navigate([`/${urlLang}/login`]);
        },
      });
  }
}
